<template>
  <tr>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"></td>
    <td class="pa-3 pl-4 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-text-field
        v-model="searchData.areaCode"
        type="text"
        label="Kode Wilayah"
        v-on:keyup.enter="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
      ></v-text-field>
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-text-field
        v-model="searchData.areaName"
        type="text"
        label="Wilayah"
        v-on:keyup.enter="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
      ></v-text-field>
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"></td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
      <v-select
        v-model="searchData.merchantType"
        :items="listMerchantType"
        label="Merchant Type"
        item-text="merchant_type"
        item-value="merchant_type"
        @change="getData"
        clearable
        hide-details="true"
        dense
        :loading="loadingMerchantType"
      />
    </td>
  </tr>
</template>

<script>
import { date } from '../../lib/helpers';

export default {
  props: ['search', 'dataList'],
  data: () => ({
    listMerchantType: [],
    loadingMerchantType: false,
  }),
  mounted() {
    this.getMerchantType();
  },
  computed: {
    searchData: {
      get() {
        return this.search;
      },
      set(newValue) {
        this.$emit('update:search', newValue);
      },
    },
    selectAllDataNew: {
      get() {
        return this.selectAllData;
      },
      set(val) {
        this.selectAll(val);
        this.$emit('selectAllDataParent', val);
      },
    },
  },

  methods: {
    getMerchantType() {
      this.loadingMerchantType = true;
      this.$store
        .dispatch('stockMid/list/getDataMerchantType', { date })
        .then((res) => {
          this.listMerchantType = res;
        })
        .finally(() => {
          this.loadingMerchantType = false;
        });
    },
    getData() {
      this.$emit('getDataParent');
    },
  },
};
</script>
